// extracted by mini-css-extract-plugin
module.exports = {"skillsBlock":"Skills_skillsBlock__2ktND","skillsContainer":"Skills_skillsContainer__152Cj","skills":"Skills_skills__2lmEy"};